export default __webpack_public_path__ + "static/media/WineGlass.a80df8f5.svg";